import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Set new password"
      subtitle="Enter your reset token and a new password."
      footer={<><Link to="/login" className="text-primary hover:underline font-medium">Back to sign in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div className="space-y-2">
          <Label htmlFor="token">Reset token</Label>
          <Input id="token" value={token} onChange={(e) => setToken(e.target.value)} placeholder="Paste your token" required data-testid="reset-token" className="font-mono text-xs" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min. 6 characters" required data-testid="reset-password" />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Update password
        </Button>
      </form>
    </AuthShell>
  );
}
